import { CompositeMeterData } from '@models/meter-scans/composite/composite-meter-data';
import { EqualizationData } from '@models/meter-scans/composite/equalization-data';
import { ClassCast, ObjectHelper } from '@utilities/object-helper';


export class CompositeScan {
  @ClassCast(CompositeMeterData)
  meterData: CompositeMeterData;
  @ClassCast(EqualizationData)
  equalizationData: EqualizationData[];

  /**
   * This is a static function intended to act similar to a constructor, returning a new instance
   * of the object using input parameters
   *
   * The purpose of this function is for mapping non standard values from the api into
   * our standard data model in the UI
   *
   * @param httpResponse
   */
  static getScanFromHttpResponse(httpResponse: any): CompositeScan {
    const scan = ObjectHelper.copyObject(httpResponse, CompositeScan);
    scan.meterData.channelData.map((channel, index) => {
      channel.frequency = httpResponse['meterData']['channelData'][index]['freq'];
    });
    scan.meterData.downstreamData.map((channel, index) => {
      channel.frequency = httpResponse['meterData']['downstreamData'][index]['freq'];
      channel.power = httpResponse['meterData']['downstreamData'][index]['pwr'];
    });
    scan.meterData.upstreamData.map((channel, index) => {
      channel.frequency = httpResponse['meterData']['upstreamData'][index]['freq'];
      channel.power = httpResponse['meterData']['upstreamData'][index]['pwr'];
    });
    scan.meterData.latitude = httpResponse['meterData']['lat'];
    scan.meterData.longitude = httpResponse['meterData']['lon'];
    return scan;
  }

}

